import apiHeader from "@/helpers/apiHeader";

const unspscService = {
  list(params) {
    return apiHeader.get("dictionary/unspsc", { params });
  },
};
export default unspscService;
